{
  "id": "oat",
  "name": "Oat",
  "species": "Avena sativa",
  "ploidy": 6,
  "assembly": "OT3098 v2",
  "chromosomes": [
    "chr1A",
    "chr1C",
    "chr1D",
    "chr2A",
    "chr2C",
    "chr2D",
    "chr3A",
    "chr3C",
    "chr3D",
    "chr4A",
    "chr4C",
    "chr4D",
    "chr5A",
    "chr5C",
    "chr5D",
    "chr6A",
    "chr6C",
    "chr6D",
    "chr7A",
    "chr7C",
    "chr7D"
  ],
  "keys": [
    "1A",
    "1C",
    "1D",
    "2A",
    "2C",
    "2D",
    "3A",
    "3C",
    "3D",
    "4A",
    "4C",
    "4D",
    "5A",
    "5C",
    "5D",
    "6A",
    "6C",
    "6D",
    "7A",
    "7C",
    "7D"
  ],
  "pattern": "^(?:chr|chromosome)?[_\\s-]?0*([1-7])[_-]?([ACD])$",
  "sources": [
    "https://rest.ensembl.org/info/assembly/avena_sativa_ot3098"
  ]
}
